import React from 'react'
import * as R from 'ramda'

import { Box } from 'components/layout/Box/Box'
// import { AddEvaluatorModal } from 'components/modals/AddEvalutorModal/AddEvaluatorModal'
import { DeleteInterviewEvaluatorModal } from 'components/modals/DeleteInterviewEvaluatorModal/DeleteInterviewEvaluatorModal'
// import { EditEvaluatorModal } from 'components/modals/EditEvaluatorModal/EditEvaluatorModal'
// import { InviteEvaluatorModal } from 'components/modals/InviteEvaluatorModal/InviteEvaluatorModal'
import { Loader } from 'components/shared/Loader/Loader'
import { Aside } from './layouts/Aside/Aside'
import { Header } from './layouts/Header/Header'
import { Main } from './layouts/Main/Main'

import { InterviewHandlersContext, InterviewStateContext } from './context'
import { useInternalState } from './hooks/useInternalState'

import styles from './InterviewApp.module.scss'

export const InterviewApp = () => {
  const { state, handlers } = useInternalState()

  const {
    evaluator,
    // evaluators,
    // hasEvaluators,
    // isAddEvaluatorOpen,
    isCategoryStep,
    isDeleteEvaluatorOpen,
    // isEditEvaluatorOpen,
    // isInviteEvaluatorOpen,
    isFetching,
    isSummaryStep,
  } = state
  const {
    // handleAddEvaluatorClose,
    handleDeleteEvaluatorClose,
    // handleDeleteEvaluatorOpen,
    handleDeleteEvaluatorConfirm,
    // handleEditEvaluatorClose,
    // handleEditEvaluatorOpen,
    // handleEditEvaluatorConfirm,
    // handleInviteEvaluatorClose,
    // handleInviteEvaluatorOpen,
    // handleInviteEvaluatorConfirm,
    // handleAddEvaluator,
    // handleCopyLink,
  } = handlers

  if (isFetching) {
    return <Loader isInline />
  }

  return (
    <InterviewStateContext.Provider value={state}>
      <InterviewHandlersContext.Provider value={handlers}>
        <Box className={styles.interview} shouldWrapContent>
          <Header />
          <Box align="center" className={styles.content} justify="center">
            {R.or(isCategoryStep, isSummaryStep) ? <Aside /> : null}
            <Main />
          </Box>
        </Box>
        {/* <AddEvaluatorModal
          onCancel={handleAddEvaluatorClose}
          onClose={handleAddEvaluatorClose}
          onAddEvaluator={handleAddEvaluator}
          onCopyLink={handleCopyLink}
          onEditEvaluator={handleEditEvaluatorOpen}
          onInviteEvaluator={handleInviteEvaluatorOpen}
          onRemoveEvaluator={handleDeleteEvaluatorOpen}
          isOpen={isAddEvaluatorOpen}
          {...{ evaluators, hasEvaluators }}
        /> */}
        {/* <EditEvaluatorModal
          onCancel={handleEditEvaluatorClose}
          onClose={handleEditEvaluatorClose}
          onConfirm={handleEditEvaluatorConfirm}
          isOpen={isEditEvaluatorOpen}
          {...{ evaluator }}
        /> */}
        {/* <InviteEvaluatorModal
          onCancel={handleInviteEvaluatorClose}
          onClose={handleInviteEvaluatorClose}
          onConfirm={handleInviteEvaluatorConfirm}
          isOpen={isInviteEvaluatorOpen}
          {...{ evaluators }}
        /> */}
        <DeleteInterviewEvaluatorModal
          onCancel={handleDeleteEvaluatorClose}
          onClose={handleDeleteEvaluatorClose}
          onConfirm={handleDeleteEvaluatorConfirm}
          isOpen={isDeleteEvaluatorOpen}
          {...{ evaluator }}
        />
      </InterviewHandlersContext.Provider>
    </InterviewStateContext.Provider>
  )
}
